import { Button } from 'antd';

import { Cross, Ok, Pencil } from 'icons';

import styles from './ActionsColumn.module.scss';

interface Props {
  readonly loading?: boolean;
  readonly editing: boolean;
  readonly save: () => void;
  readonly edit: () => void;
  readonly cancel: () => void;
}

export const ActionsColumn = ({ loading, editing, save, edit, cancel }: Props) => {
  return editing ? (
    <div className={styles.actionsRow}>
      <Button type="text" icon={<Cross />} onClick={cancel} disabled={loading} />
      <Button className={styles.successButton} type="text" icon={<Ok />} onClick={save} loading={loading} />
    </div>
  ) : (
    <Button type="text" icon={<Pencil />} onClick={edit} />
  );
};
